import { BrowserTimezoneSync as SharedBrowserTimezoneSync } from '@cheqroom/ui';
import { FC, useCallback } from 'react';

import { useAuth } from '../../context/Authentication.context';

/**
 * Staff wiring for the shared browser→profile timezone sync (see `@cheqroom/ui`).
 * Skips while impersonating, and refreshes the Knockout `central.user` observable on success.
 */
export const BrowserTimezoneSync: FC = () => {
	const authUser = useAuth();
	const impersonating = window.global?.authUser?.impersonated === true;

	const onSynced = useCallback((timezone: string) => {
		const central = window.global?.central;
		if (!central?.user) return;
		// `central.user` is a ko.observable in the legacy shell, so this both reads and writes.
		const current = central.user();
		central.user({ ...current, timezone });
	}, []);

	return (
		<SharedBrowserTimezoneSync
			userId={authUser.id}
			profileTimezone={authUser.timezone}
			enabled={Boolean(authUser.id) && !impersonating}
			onSynced={onSynced}
		/>
	);
};
